'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import UserFeaturedEmptyCard from '@/app/[locale]/(worlds)/profile/components/UserFeaturedEmptyCard';
import UserFeaturedRoomsContent from '@/app/[locale]/(worlds)/profile/components/UserFeaturedRoomsContent';
import { Room } from '@/services/cms';
type UserFeaturedRoomsProps = {
  featuredRooms: Room[];
};
export default function UserFeaturedRooms(t0) {
  const $ = _c(19);
  const {
    featuredRooms
  } = t0;
  const t = useTranslations();
  const [isHovered, setIsHovered] = useState(false);
  let t1;
  if ($[0] !== featuredRooms || $[1] !== isHovered) {
    t1 = () => {
      if (featuredRooms.length === 0) {
        return <UserFeaturedEmptyCard />;
      }
      return <UserFeaturedRoomsContent featuredRooms={featuredRooms} isHovered={isHovered} />;
    };
    $[0] = featuredRooms;
    $[1] = isHovered;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const renderContent = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsHovered(true);
    t3 = () => setIsHovered(false);
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("profile-page.interactive-content");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <h1 className="header-6 md:header-4 mb-9">{t4}</h1>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("user-worlds.sort-option.featured");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <h2 className="subheader-2 md:header-5 text-vive-primary-20 relative mb-4 font-bold md:mb-6">{t6}</h2>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== renderContent) {
    t8 = renderContent();
    $[13] = renderContent;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5 || $[16] !== t7 || $[17] !== t8) {
    t9 = <div className="flex scroll-mt-40 flex-col px-4 md:px-8 lg:px-18" onMouseEnter={t2} onMouseLeave={t3}>{t5}{t7}{t8}</div>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}